const merge = (list1, list2) => {
  var result = list1 || []
  if (list2) {
    list2.forEach((ele) => {
      result.push(ele)
    })
  }
  return result
}

const isArray = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Array]'
}
export default {merge, isArray}
